import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React, { PropsWithChildren } from "react";

interface Props {
    className?: string;
}

const useStyles = makeStyles(() => ({
    root: {
        display: "flex",
        "&>*": {
            marginRight: "0.25rem",
            "&:last-child": {
                marginRight: 0
            }
        }
    }
}));

const QATableButtonRow: React.FC<PropsWithChildren<Props>> = props => {
    const classes = useStyles();
    return (
        <div className={clsx(classes.root, props.className)}>
            {props.children}
        </div>
    );
};

export default QATableButtonRow;
